var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1One(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9a29 29 0 100 58 29 29 0 000-58zm0 54a25 25 0 110-49.999A25 25 0 0138 63zm-.2-34H41v20h-4V36h-5v-3a8.94 8.94 0 002-.16 5.431 5.431 0 001.77-.65 4.15 4.15 0 001.32-1.25A4.47 4.47 0 0037.8 29z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_One.32c6559e.svg";
export { SvgJ1One as ReactComponent };